<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="startFindingPhoneUserDataWithCode">{{
        $t("find_phone_or_password_user_data")
      }}</mdb-btn>
    </mdb-form-inline>
    <InputModal
      :modalShow="phoneSearchModal"
      :dataShow="dataLoadReady"
      :title="$t('find_user_phone_or_password_modal_title')"
      :description="$t('find_user_phone_or_password_modal_description')"
      :inputLabel="$t('find_user_phone_modal_inputlabel')"
      :buttontext="$t('find_user_phone_modal_button')"
      :button-delete-text="$t('clean_user_password_modal_button')"
      :dataModal="dataModal"
      v-on:modal-cancelled="phoneSearchCancelled"
      v-on:modal-ok="phoneSearch"
      v-on:modal-delete="cleanUserPassword"
    />
  </div>
</template>

<script>
import { mdbBtn, mdbFormInline } from "mdbvue";
import InputModal from "./InputModal.vue";
export default {
  name: "FindPhoneUserDataWithCode",
  components: {
    mdbBtn,
    mdbFormInline,
    InputModal,
  },
  data() {
    return {
      searchmode: true,
      phoneNumber: "",
      filterText: "",
      phoneSearchModal: false,
      dataLoadReady: false,
      dataModal: {
        columns: [
          {
            label: "PatchId",
            field: "patchid",
          },
          {
            label: "Asiakas",
            field: "customerid",
          },
          {
            label: "Puhelinnumero",
            field: "tel",
          },
          {
            label: "Salasana",
            field: "password",
          },
          {
            label: "Nimi",
            field: "name",
          },
          {
            label: "Voimassa saakka",
            field: "validto",
          },
          {
            label: "Käytetty",
            field: "used",
          },
        ],
        rows: null,
      },
      retrievepath: "/1.0/front/password/retrieve",
      cleanpasswordpath: "/1.0/front/password/clean",
    };
  },
  methods: {
    phoneSearchCancelled() {
      this.phoneSearchModal = false;
    },
    phoneSearch(val, searchMode) {
      searchMode = true;
      this.dataLoadReady = false;
      this.findPhoneUserDataWithCode(val, searchMode);
    },
    startFindingPhoneUserDataWithCode() {
      this.phoneSearchModal = true;
    },
    cleanUserPassword(val) {
      this.$http
        .post(
          this.cleanpasswordpath,
          JSON.stringify({
            password: val,
          })
        )
        .then((response) => {
          if (response.status == 200) {
            this.dataLoadReady = false;
            this.$notify.info({
              message: this.$t("password_cleaned"),
              position: "top right",
              timeOut: this.$store.state.notifytimeoutmedium,
            });
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
    findPhoneUserDataWithCode(val) {
      this.$http
        .post(
          this.retrievepath,
          JSON.stringify({
            search: val,
          })
        )
        .then((response) => {
          if (response.status == 200) {
            this.dataModal.rows = response.data.passwords;
            this.dataLoadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          return error;
        });
    },
  },
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
